import { render, staticRenderFns } from "./DonutChart08.vue?vue&type=template&id=be869528&scoped=true&"
import script from "./DonutChart08.vue?vue&type=script&lang=js&"
export * from "./DonutChart08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be869528",
  null
  
)

export default component.exports